export default __webpack_public_path__ + "static/media/a037-a.da462be5.jpg";